<template>
  <v-col>
    <v-progress-circular v-if="isLoading" indeterminate color="loader" size="25" />
    <btn-icon-tip
        :id="`registrateBtn-${lotTemplateId}`"
        icon="content_paste_go"
        :tip="$t('Создать торговую процедуру из шаблона')"
        @click="showConfirmationBeforCreateLot" />
    <btn-icon-tip
        :id="`deleteBtn-${lotTemplateId}`"
        icon="delete"
        :tip="$t('Удалить шаблон')"
        @click="showConfirmationBeforDelete" />
    <confirm-dialog
        v-if="confirmDialog.show"
        :dialog-prop="confirmDialog"
        warning
        @close="closeDialog('confirmDialog')" />

  </v-col>
</template>

<script>
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import ConfirmDialog from '@/components/reused/common/ConfirmDialog.vue'
  import { LOT_STATUSES, LOT_TABS, LOT_REQUEST_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { LOT_TEMPLATE_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      BtnIconTip,
      ConfirmDialog
    },
    props: {
      lotTemplateId: {
        type: String,
        required: true
      },
      lotType: {
        type: String,
        required: true
      },
      edited: {
        type: [Function, Promise]
      }
    },
    data () {
      return {
        LOT_STATUSES,
        LOT_TABS,
        LOT_REQUEST_TYPES,
        loaded: false,
        isLoading: false,
        confirmDialog: {
          show: false,
          text: null,
          additional: null,
          callback: null,
          warning: true
        }
      }
    },
    computed: {
      ...mapState(LOT_TEMPLATE_MANAGEMENT.NAMESPACE, {
        lotId: state => (state[LOT_TEMPLATE_MANAGEMENT.STATE.CREATED_LOT_ID] || {})
      }),

      createdLotId () {
        return this.lotId
      },
      actions () {
        const lotActions = this.actionsByLotId(this.lotTemplateId) || {}
        return lotActions.actions || []
      }
    },
    created () {
      this.showActions()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOT_TEMPLATE_MANAGEMENT.NAMESPACE, {
        deleteLotAction: LOT_TEMPLATE_MANAGEMENT.ACTIONS.DELETE_LOT_TEMPLATE
      }),
      ...mapActions(LOT_TEMPLATE_MANAGEMENT.NAMESPACE, {
        createLotFromTemplateAction: LOT_TEMPLATE_MANAGEMENT.ACTIONS.CREATE_LOT_FROM_TEMPLATE
      }),
      ...mapActions(LOT_TEMPLATE_MANAGEMENT.NAMESPACE, {
        clearLotIdAction: LOT_TEMPLATE_MANAGEMENT.ACTIONS.CLEAR_LOTID
      }),
      clearStore: async function () {
        this.clearLotIdAction()
      },
      showActions: async function () {
        await this.clearStore()
        if (!this.lotTemplateId) {
          return
        }
        await this.getLotActions()
      },
      getLotActions: async function () {},

      showConfirmationBeforCreateLot: function () {
        this.confirmDialog.additional = {
          lotTemplateId: this.lotTemplateId,
          lotType: this.lotType
        }
        this.confirmDialog.text = this.$t('Создание торговой процедуры на основе выбранного шаблона. Продолжить?')
        this.confirmDialog.callback = this.createLotFromTemplate
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      },
      // открыть окно подтверждения перед удалением торговой процедуры
      showConfirmationBeforDelete: function () {
        this.confirmDialog.additional = {
          lotTemplateId: this.lotTemplateId,
          lotType: this.lotType
        }
        this.confirmDialog.text = this.$t('Шаблон торговой процедуры будет удален. Продолжить?')
        this.confirmDialog.callback = this.deleteLot
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      },
      deleteLot: async function (lotTemplate) {
        try {
          this.isLoading = true
          await this.deleteLotAction(lotTemplate)
          this.isLoading = false
          if (this.edited) {
            this.edited()
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      createLotFromTemplate: async function (lotTemplate) {
        try {
          this.isLoading = true
          await this.createLotFromTemplateAction(lotTemplate)
          this.isLoading = false
          if (this.createdLotId) { this.goToRoute(`${this.urlRootPath}/lotWizard/${lotTemplate.lotType}/${this.createdLotId}`) }

          if (this.edited) {
            this.edited()
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
